import React from 'react';
import Lottie from 'lottie-react';
import '../TeachersSection.css';
import lukaszPhoto from '../../assets/images/lukasz2.png';
import kornelPhoto from '../../assets/images/kornel.png';
import educationAnimation from '../../assets/animations/education.json';
import businessmanRocketAnimation from '../../assets/animations/businessman-rocket.json';
import processAnimation from '../../assets/animations/process.json';

const AuditedTeachersSection: React.FC = () => {
  const founders = [
    {
      name: "Lukasz",
      role: "Wspulzalozyciel i Opiekun Ucznia",
      specialization: "Matematyka na wszystkich poziomach",
      experience: "Pasjonat, ktory odmienia zycia uczniow",
      education: "Magister matematyki, doswiadczenie w nauczaniu indywidualnym",
      description: "Wierze, ze kazdy moze zrozumiec matematyke! Moja misja? Przeksztalcac strach i obawy w pewnosc siebie i sukcesy!",
      achievements: [
        "100% zdawalnosci egzaminu maturalnego przez moich uczniow",
        "Pasjonat finskiego modelu nauczania i metod nauki",
        "Osiaga sukcesy przez indywidualne podejscie do kazdego ucznia",
        "Opiekun kontaktow z uczniami i rodzicami",
        "Monitoruje postepy i dostosowuje metody nauczania"
      ],
      photo: lukaszPhoto,
      hasPhoto: true,
      superpower: "Zamienia matematyke w przygode!"
    },
    {
      name: "Kornel",
      role: "Wspulzalozyciel i Opiekun Olimpijski",
      specialization: "Matematyka zaawansowana i konkursy olimpijskie",
      experience: "Ksztalci przyszlych mistrzow matematyki",
      education: "Magister matematyki, laureat olimpiad matematycznych",
      description: "Matematyka to moja pasja! Dobrze rozumiejac matematyke, potrafisz lepiej rozumiec rzeczywistosc - rowniez te nie matematyczna.",
      achievements: [
        "Wielokrotny Finalista Olimpiady Matematycznej",
        "Przygotowuje laureatow konkursow",
        "Opiekun merytoryczny",
        "Zwyciezca XIII Olimpiady Matematycznej Juniorow",
        "Trzykrotny zwyciezca Mistrzostw Polski w Geometrii Elementarnej"
      ],
      photo: kornelPhoto,
      hasPhoto: true,
      superpower: "Tworzy matematycznych mistrzow!"
    }
  ];

  return (
    <section id="teachers" className="teachers-section">
      <div className="teachers-container">
        <div className="section-header">
          <h2>Zalozyciele Sigma Study</h2>
          <p>Poznaj osoby, ktorych podejscie zrewolucjonizuje Twoje wyniki i motywacje do nauki</p>
        </div>

        <div className="founders-grid">
          {founders.map((founder, index) => (
            <div key={index} className="founder-card exciting-card">
              <div className="founder-photo">
                {founder.hasPhoto && founder.photo ? (
                  <div className="founder-image-container">
                    <img src={founder.photo} alt={founder.name} className="founder-image" />
                    <div className="power-glow"></div>
                  </div>
                ) : (
                  <div className="founder-placeholder">
                    <span className="placeholder-icon">?</span>
                    <p>Zdjecie wkrotce</p>
                  </div>
                )}
              </div>

              <div className="founder-info">
                <h3 className="founder-name">{founder.name}</h3>
                <p className="founder-role">{founder.role}</p>

                <div className="founder-description exciting-quote">
                  <p>"{founder.description}"</p>
                </div>

                {index === 0 && (
                  <div className="founder-animation">
                    <Lottie
                      animationData={educationAnimation}
                      loop={true}
                      autoplay={true}
                      style={{
                        width: '100px',
                        height: '100px',
                        position: 'absolute',
                        top: '20px',
                        right: '20px',
                        opacity: 0.7
                      }}
                    />
                  </div>
                )}

                {index === 1 && (
                  <div className="founder-animation">
                    <Lottie
                      animationData={processAnimation}
                      loop={true}
                      autoplay={true}
                      style={{
                        width: '100px',
                        height: '100px',
                        position: 'absolute',
                        top: '20px',
                        right: '20px',
                        opacity: 0.7
                      }}
                    />
                  </div>
                )}

                <div className="founder-achievements">
                  <h4>Osiagniecia:</h4>
                  <ul>
                    {founder.achievements.map((achievement, idx) => (
                      <li key={idx} className="achievement-item">{achievement}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="teachers-cta">
          <div className="cta-with-animation">
            <button
              className="teachers-main-cta-btn"
              onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
            >
              Zapisz sie na zajecia
            </button>
            <div className="cta-animation">
              <Lottie
                animationData={businessmanRocketAnimation}
                loop={true}
                autoplay={true}
                style={{
                  width: '120px',
                  height: '120px',
                  marginLeft: '1rem'
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AuditedTeachersSection;
